import { SERVICE_HOST } from "./host.conf"
export default {
    host: SERVICE_HOST || location.origin,
    cookiePrefix: '__AUTH__',
    expires: 24 * 60 * 60 * 1e3,
    debug: process.env.NODE_ENV !== 'production',
    funbugRelease: process.env.NODE_ENV === 'production' ? 'production' : 'development',
    env: process.env.NODE_ENV,
    version: process.env.VUE_APP_PROJECT_VERSION,
    name: process.env.VUE_APP_PROJECT_NAME,
    buildAt: process.env.VUE_APP_PROJECT_TIMESTAMP,
    permissionOn: JSON.parse(process.env.VUE_APP_PROJECT_PERMISSION_ON),
    auth: null
};
